import { render, staticRenderFns } from "./HomeSidebar.vue?vue&type=template&id=57d84b72&scoped=true&"
import script from "./HomeSidebar.vue?vue&type=script&lang=js&"
export * from "./HomeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HomeSidebar.vue?vue&type=style&index=0&id=57d84b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d84b72",
  null
  
)

export default component.exports